import { transformSearch } from "@/api/helper.ts";
import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import caseEvidenceCategoryService from "../services/category-service";

export const caseEvidenceSearchQuery = z.object({
	search: z.string().optional(),
	parties: z.string().optional(),
	case_id: z.string().optional(),
	id: z.string().optional(),
	case_record_user_depth: z.string().optional().nullable(),
	case_record_user_id: z.string().optional().nullable(),
	case_activity_ids: z.string().optional().nullable(),
	parent_id: z.string().optional().nullable(),
	evidence_type: z.string().optional(),
	status: z.string().optional().nullable(),
	include: z.string().optional(),
	per_page: z.number().optional(),
	page: z.number().nullable().optional(),
	category_value: z.string().optional().nullable(),
});

export const caseEvidenceListCategoryByCaseIdQueryOptions = (search?: z.infer<typeof caseEvidenceSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_evidence", search],
		queryFn: () =>
			caseEvidenceCategoryService.listEvidenceCategoryByCaseId(
				search?.case_id,
				transformSearch(search, [
					"parties",
					"evidence_type",
					"case_id",
					"search",
					"case_record_user_depth",
					"case_record_user_id",
					"id",
					"parent_id",
					"status",
					"category_value",
				]),
			),
		...options,
	});
};

export const caseEvidenceListCategoryByPartiesQueryOptions = (search?: z.infer<typeof caseEvidenceSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_evidence", search],
		queryFn: () =>
			caseEvidenceCategoryService.listEvidenceCategoryByParties(
				search?.case_id,
				transformSearch(search, [
					"parties",
					"evidence_type",
					"case_id",
					"search",
					"case_record_user_depth",
					"case_record_user_id",
					"id",
					"parent_id",
					"status",
					"category_value",
				]),
			),
		...options,
	});
};

export const caseEvidenceListCategoryByTypeQueryOptions = (search?: z.infer<typeof caseEvidenceSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_evidence", search],
		queryFn: () =>
			caseEvidenceCategoryService.listEvidenceCategoryByType(
				search?.case_id,
				transformSearch(search, [
					"parties",
					"evidence_type",
					"case_id",
					"search",
					"case_record_user_depth",
					"case_record_user_id",
					"id",
					"parent_id",
					"status",
					"category_value",
				]),
			),
		...options,
	});
};

export const caseEvidenceListAllWithCategoryQueryOptions = (search?: z.infer<typeof caseEvidenceSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_evidence", search],
		queryFn: () =>
			caseEvidenceCategoryService.listAllEvidenceWithCategories(
				search?.case_id,
				transformSearch(search, [
					"parties",
					"evidence_type",
					"case_id",
					"search",
					"case_record_user_depth",
					"case_record_user_id",
					"id",
					"parent_id",
					"status",
					"category_value",
				]),
			),
		...options,
	});
};
export const caseEvidenceListAllCategoriesQueryOptions = (search?: z.infer<typeof caseEvidenceSearchQuery>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["case_evidence", search],
		queryFn: () =>
			caseEvidenceCategoryService.listAllEvidenceCategories(
				search?.case_id,
				transformSearch(search, [
					"parties",
					"evidence_type",
					"case_id",
					"search",
					"case_record_user_depth",
					"case_record_user_id",
					"id",
					"parent_id",
					"status",
					"category_value",
				]),
			),
		...options,
	});
};
